// extracted by mini-css-extract-plugin
export default {"seatsCountSelector":"SeatsCountSelector_seatsCountSelector__E8Cij","seatsCount":"SeatsCountSelector_seatsCount__G-ro4"};